import React, { useEffect } from "react";
import "../../../AFrameControlStation/WarningList/WarningList.css";
import {
  IConveyorBox,
  IConveyorBoxReviewModel,
  IConveyorBoxUI,
  IConveyorBoxWarnings,
  ILimaIPackBox,
} from "../../../../lib/interfaces/ConveyorBox/IConveyorBox";
import OrderStatusBlock from "../../OrderStatusBlock/OrderStatusBlock";

import styles from "./WarningList.module.css";
import { Divider, Header, List, Message } from "semantic-ui-react";
import { useDispatch, useSelector } from "react-redux";
import { MessageType } from "../../../../lib/store/reducers/responseMessagesReducer";
import { addMessage } from "../../../../lib/store/reducers/responseMessagesReducer";



type Props = {
  hasWarnings: IConveyorBoxWarnings["hasWarnings"];
  warnings: IConveyorBox["warnings"];
  iPackBoxID: ILimaIPackBox["id"];
  isOrderCompleted: boolean;
  isOrderChecked: boolean;
};

const WarningList = () => {
  const dispatch = useDispatch(); 
  const conveyorBoxReview: IConveyorBoxUI = useSelector(
    (state: any) => state.conveyorBoxReviewReducer
  );
  const { warnings, items } = conveyorBoxReview;

    const specialErrorString = "Shipping barcode does not match the LU-ID";

  const displayableWarnings = warnings.filter(
    (w) => !w.validationDescription?.includes(specialErrorString)
  );

    useEffect(() => {
    const specialWarning = warnings.find((w) => w.validationDescription?.includes(specialErrorString));

    if (specialWarning) {
      dispatch(addMessage({
        messageType: MessageType.WAREHOUSE, 
        title: "Kritiskt Fel",
        content: "OBS!! Frakt etikett stämmer inte överens med LU-ID, kontrollera lådan noga!", 
      }));
    }
  }, [warnings, dispatch]); 
  return (
    <>
     
      {displayableWarnings.length < 1 ? (
        <OrderStatusBlock
          isItemsVerified={items.active.every(
            (item) => item.verifiedQuantity === item.pickedQuantity
          )}
        />
      ) : (
        <>
          <Divider horizontal>
            <Header as="h3">Felmeddelanden ({displayableWarnings.length})</Header>
          </Divider>
          <List size="big" className={styles["warning-list"]}>
            
            {displayableWarnings.map((warning, index) => (
              <Message
                key={index}
                negative
                content={warning.validationDescription || "Inget felmeddelande angivet."}
              />
            ))}
          </List>
        </>
      )}
    </>
  );
};

/* <ListItem>
    <ListIcon name="exclamation" color="red" />
    <ListContent>
      <ListDescription>
        {warning.boxValidation.validationDescription ||
          "Något gick fel när varan passerade CHK 14 för upphämtning av receptbelagt läkemedel."}
      </ListDescription>
    </ListContent>
  </ListItem>
  <Divider hidden horizontal /> */

export default WarningList;
